import { faAlarmClock } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { ReactElement } from "react";
import { ProjectTask, ProjectTaskStatus } from "./ProjectTask";

interface IProps {
	dateFormat?: string;
	task: ProjectTask;
}

export const ProjectTaskDueDate = (props: IProps): ReactElement | null => {
	const { task } = props;
	let { dateFormat } = props;

	if (!task.dueDate) {
		return null;
	}

	if (!dateFormat) {
		dateFormat = "MMM D [at] h:mm A";
	}
	let dueDateClass = "";

	if (
		task.status !== ProjectTaskStatus.Live &&
		task.status !== ProjectTaskStatus.Trash &&
		task.status !== ProjectTaskStatus.Completed
	) {
		if (moment(task.dueDate).isBefore(new Date())) {
			dueDateClass = "task-overdue";
		} else if (
			moment(task.dueDate).isSame(new Date(), "day") &&
			moment(task.dueDate).isAfter(new Date())
		) {
			dueDateClass = "task-due-soon";
		}
	}

	return (
		<div className={`${dueDateClass} task-due-date`}>
			<FontAwesomeIcon
				icon={faAlarmClock}
				size="1x"
				fixedWidth
				style={{ marginRight: 4 }}
			/>
			{moment(task.dueDate).format(dateFormat)}
		</div>
	);
};
